import { useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ParentContext, CompanyContext } from "../../layouts/Dashboard/LayoutDashboard";

export const useCompanyNavigation  = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const {allCompanies, setSelectedCompanyID} = useContext(CompanyContext);
  const {setSelectedParentID} = useContext(ParentContext);
    const toCompany = (companyId) => {
      const company = allCompanies.find((company) => company.value === companyId);
      if (company) {
        console.log('TrendGroupId:', company.TrendGroupId);
        // Set the selected company ID
        setSelectedCompanyID(companyId);
        setSelectedParentID(company.TrendGroupId);
        if (location.pathname === '/companies') {
          navigate(0);
        } else {
          navigate('/companies');
        }
      } else {
        setSelectedCompanyID(companyId);
        if (location.pathname === '/companies') {
          navigate(0);
        } else {
          navigate('/companies');
        }
      }
    };
  
    return toCompany;
};